import crudmaker from '@/store/crudmaker'
import { apiClient } from '@/client'
import merge from 'deepmerge'
import { setStatus, compactAndFilter } from '@/utils'

const module = 'boards'
let doc = {
  list: {
    name: 'Panneaux',
    hasMap: true,
    headers: [
      { label: 'Code', value: 'code' },
      { label: 'Type', value: 'board_type.name', truncate: true },
      { label: 'Adresse', value: 'adress' },
      { label: 'District', value: 'district.name', card: false },
      { label: 'Ville', value: 'district.city.name', card: false },
      { label: 'Région', value: 'district.city.region.name', card: false },
      { label: 'Localité', value: 'locality', sortable: false, inTable: false, inDetail: false },
      { label: 'Statut', value: 'status.name' },
    ],
    actions: [
      { icon: 'add', isFlat: false, scope: ['boards.create'], dispatch: `${module}/openForm` },
      { icon: 'search', isFlat: true, dispatch: `${module}/openSearch` },
    ],
    dataActions: [
      { icon: 'visibility', dispatch: `${module}/goTo` },
      { icon: 'pie_chart', context: {field: 'board_id'}, dispatch: `tenancy/getTenancy` },
    ],
    selectActions: [
      {
        label: 'Supprimer',
        icon: 'delete',
        scope: ['boards.delete'],
        dispatch: `${module}/batchDelete`,
        context: {confirm: true},
        menu: true,
      },
      {
        label: 'Occupation',
        icon: 'pie_chart',
        dispatch: `tenancy/getMultiTenancy`,
        context: {field: 'board_id'},
      },
    ],
    search: [
      { label: 'Région', type: 'multilist', name: 'region_id', from: 'name', source: 'regions' },
      { label: 'Ville', type: 'multilist', name: 'city_id', from: 'name', source: 'cities' },
      { label: 'District', type: 'multilist', name: 'district_id', from: 'name', source: 'districts' },
      { label: 'Type', type: 'multilist', name: 'board_type_id', from: 'name', source: 'boardtypes' },
    ],
  },

  form: {
    name: 'Panneau',
    hasPhoto: true,
    fields: [
      { label: 'Code', type: 'text', name: 'code' },
      { label: 'Type', type: 'list', from: 'name', name: 'board_type_id', source: 'boardtypes' },
      { label: 'Coté A', type: 'text', name: 'count_side_a', hint: 'Combien de faces sur le coté A' },
      { label: 'Coté B', type: 'text', name: 'count_side_b', hint: 'Combien de faces sur le coté B' },
      { label: 'Adresse', type: 'text', name: 'adress' },
      { label: 'Région', type: 'list', from: 'name', name: 'district.city.region_id', source: 'regions' },
      {
        label: 'Ville',
        type: 'list',
        from: 'name',
        name: 'district.city_id',
        cascade: { target: 'district.city.region_id', value: 'region_id' },
        source: 'cities',
      },
      {
        label: 'District',
        type: 'list',
        from: 'name',
        name: 'district_id',
        cascade: { target: 'district.city_id', value: 'city_id' },
        source: 'districts',
      },
      { label: 'Longitude', type: 'text', name: 'lon' },
      { label: 'Latitude', type: 'text', name: 'lat' },
    ],
    actions: [
      {
        icon: 'pie_chart',
        isFlat: true,
        context: {field: 'board_id'},
        dispatch: `tenancy/getTenancy`,
      },
      {
        icon: 'save',
        filter: {edit: true},
        scope: ['boards.update'],
        dispatch: `${module}/update`,
      },
      {
        icon: 'delete',
        scope: ['boards.delete'],
        isFlat: true,
        dispatch: `${module}/delete`,
        context: { confirm: true },
      },
      { label: 'En panne', icon: 'report_problem', filter: {status_id: 1}, dispatch: `${module}/setError` },
      { label: 'Réparé', icon: 'check_circle', filter: {status_id: 2}, dispatch: `${module}/setOk` },
      { icon: 'search', isFlat: true, filter: {relation: true}, dispatch: `${module}/openRelatedSearch` },
    ],
    relations: [
      {
        name: 'Faces',
        source: 'faces',
        headers: [
          { label: 'Code', value: 'code' },
          { label: 'Coté', value: 'board_side.name' },
        ],
        dispatch: 'getFaces',
        dataActions: [
          { icon: 'visibility', isFlat: false, dispatch: `faces/goTo` },
        ],
      },
      {
        name: 'Incidents',
        source: 'incidents',
        headers: [
          { label: 'Type', value: 'incident_type.name', truncate: true },
          { label: 'Intervention', value: 'intervention_type.name', truncate: true },
          { label: 'Responsable', value: 'user.username' },
          { label: 'début', value: 'date_up', card: false },
          { label: 'fin', value: 'date_down', card: false },
        ],
        dispatch: 'getIncidents',
        dataActions: [
          { icon: 'visibility', isFlat: false, dispatch: `incidents/goTo` },
        ],
      },
    ],
  },

  params: {
    fetchAll: {include: 'district.city.region,board_type,status'},
    fetchOne: {include: 'district.city.region,status,board_type'},
  },

  postprocess: item => {
    let locality = item.district ? `${item.district.name}, ${item.district.city.name}, ${item.district.city.region.name}` : ''
    return {
      position: {lng: parseFloat(item.lon), lat: parseFloat(item.lat)},
      locality,
      ...item,
    }
  },
}

const base = crudmaker(module, apiClient, doc)

const custom = {
  actions: {
    getFaces: ({ commit }, payload) => {
      commit('SET_LOADING', true)
      const { context, data } = payload
      commit('faces/LIST_REQUEST', payload, {root: true})
      let compacted = compactAndFilter(data)
      let params = {
        ...compacted,
        board_id: context.id,
        include: 'board_side',
      }
      apiClient.fetchCustom('faces', `faces`, params)
        .then(data => {
          commit('faces/LIST_SUCCESS', data, {root: true})
          commit('SET_LOADING', false)
        })
        .catch(error => {
          console.log(error)
          commit('faces/LIST_ERROR', error, {root: true})
          commit('SET_LOADING', false)
        })
    },
    getIncidents: ({ commit }, payload) => {
      const { context, data } = payload
      commit('SET_LOADING', true)
      commit('incidents/LIST_REQUEST', payload, {root: true})
      let compacted = compactAndFilter(data)
      let params = {
        ...compacted,
        board_id: context.id,
        include: 'incident_type,intervention_type,user',
      }
      apiClient.fetchCustom('incidents', `incidents`, params)
        .then(data => {
          commit('incidents/LIST_SUCCESS', data, {root: true})
          commit('SET_LOADING', false)
        })
        .catch(error => {
          console.log(error)
          commit('incidents/LIST_ERROR', error, {root: true})
          commit('SET_LOADING', false)
        })
    },
    setError: ({ commit, dispatch }, payload) => setStatus(apiClient, module, commit, dispatch, payload, 'error'),
    setOk: ({ commit, dispatch }, payload) => setStatus(apiClient, module, commit, dispatch, payload, 'ok'),
  },
}
export default merge(base, custom)
